import {ListConfigs} from '../../app/sharedComponent/SearchList/SearchList.types'

export const DNELISTCONFIGS: ListConfigs[] = [
  {
    apiFieldName: 'phoneNumber',
    headerName: 'Phone number',
    type: 'PHONE_NUMBER',
    columnWidth: '150',
  },
  {
    apiFieldName: 'utilityAccountNumber',
    headerName: 'UAN',
    type: 'TEXT',
    columnWidth: '150',
  },
  {
    apiFieldName: 'zipCode',
    headerName: 'Zip',
    type: 'TEXT',
    columnWidth: '150',
  },
  {
    apiFieldName: 'emailId',
    headerName: 'Email',
    type: 'TEXT',
    columnWidth: '150',
  },
]
